/**
 * Enable web view chat to native mobile app user
 */
export const HELP_CENTER_CHAT_MOBILE_WEBVIEW_240220 = 'HELP_CENTER_CHAT_MOBILE_WEBVIEW_240220';
